import { h, Component, Fragment, createRef } from 'preact';
import dropdownImg from './../../assets/noaa-badge.svg';

export default class HeaderComponent extends Component {
    constructor() {
        super();
        this.state = {
            isMenuOpen: false
        };

        this.closeOnDeselect = this.closeOnDeselect.bind(this);
        this.ref = createRef();
    }

    toggleMenu() {
        this.setState({isMenuOpen: !this.state.isMenuOpen});
    }

    closeOnDeselect(event) {
        // TODO find a better solution then this document event mount for closing div
        if (this.ref && !this.ref.current.contains(event.target) && this.state.isMenuOpen) {
            this.setState({isMenuOpen: false});
        }
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.closeOnDeselect);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.closeOnDeselect);
    }

    render() {
        const self = this;
        return (
            <Fragment>
                <div class="mapNavBar">
                    <div class="menubar" ref={self.ref}>
                        <button class="dc-brand" data-ga="QR Branding" title="Main Menu" accesskey="1" onclick={() => self.toggleMenu()}>
                            <img src={dropdownImg} alt="Nav Links" />
                            <span class={`caret ${self.state.isMenuOpen ? 'selected' : ''}`}></span>
                        </button>
                        <ul class={`ddTarget ${this.state.isMenuOpen ? 'open' : ''}`}>
                            <li class="nav-head">Digital Coast</li>
                            <li><a href="//coast.noaa.gov/digitalcoast/" data-ga="QR Branding Select" rel="noreferrer" target="_blank">Digital Coast</a></li>
                            <li><a href="//coast.noaa.gov/dataregistry/search/collection" data-ga="QR Branding Select" rel="noreferrer" target="_blank">Data</a></li>
                            <li><a href="//coast.noaa.gov/digitalcoast/tools/" data-ga="QR Branding Select" rel="noreferrer" target="_blank">Tools</a></li>
                            <li><a href="//coast.noaa.gov/digitalcoast/training/" data-ga="QR Branding Select" rel="noreferrer" target="_blank">Training</a></li>
                            <li><a href="//coast.noaa.gov/digitalcoast/stories/" data-ga="QR Branding Select" rel="noreferrer" target="_blank">Stories</a></li>
                            <li><a href="//coast.noaa.gov/digitalcoast/about/" data-ga="QR Branding Select" rel="noreferrer" target="_blank">About</a></li>
                            <li class="divider"></li>
                            <li class="nav-head">NOAA</li>
                            <li><a href="//coast.noaa.gov/" data-ga="QR Branding Select" rel="noreferrer" target="_blank">National Oceanic and Atmospheric Administration</a></li>
                        </ul>
                    </div>
                    <h2 class="map-template" id="noaa_header_title">Quick Report Tool for Socioeconomic Data</h2>
                </div>
            </Fragment>
        );
    }
}
